import {defineStore} from 'pinia';
import type {MenuInterface} from "~~/server/types/menu";


export const useMenusStore = defineStore('Menus', {
    state: () => ({
        _list: null as MenuInterface[] | null,
        _loaded: false,
        _promise: null as Promise<void> | null,
    }),

    getters: {
        menu: (state) => state._list,
        isLoaded: s => s._loaded,
    },

    actions: {
        async load() {
            if (this._loaded) return
            if (this._promise) return this._promise

            const { $api } = useNuxtApp()

            this._promise = (async () => {
                const res = await $api<MenuInterface[]>('/menus', { method: 'GET' })
                this._list = res ?? null
                this._loaded = true
            })()

            try {
                await this._promise
            }
            finally {
                this._promise = null
            }
        },

    },
});
